import { CurrentUser } from "app/shared/model/CurrentUser";

export enum ActionType {
    Startup = 'Startup',
    StartupSuccess = 'StartupSuccess',
    Unauthorized = 'Unauthorized'
}

type StartupAction = {
    type: ActionType.Startup
    user: CurrentUser
    version: string
}

type StartupSuccessAction = {
    type: ActionType.StartupSuccess
}

type UnauthorizedAction = {
    type: ActionType.Unauthorized
}

export type Action = 
    StartupAction
    | StartupSuccessAction
    | UnauthorizedAction